<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Wpisu do folderu: <strong>{{ parentFolderName }}</strong>
                </h1>
            </v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="processEntryData.name"
                    name="Tytuł wpisu"
                    label="Tytuł wpisu"
                    required
                    solo
                    :error-messages="processEntryNameErrors"
                    @input="$v.processEntry.name.$touch()"
                />
                <v-textarea
                    v-model="processEntryData.description"
                    name="Treść"
                    label="Treść"
                    required
                    solo
                    :error-messages="processEntryDescriptionErrors"
                    @input="$v.processEntry.description.$touch()"
                />
                <v-file-input
                    v-model="items"
                    accept="image/*, .pdf"
                    counter
                    multiple
                    placeholder="Wybierz pliki"
                    prepend-icon="mdi-paperclip"
                    outlined
                    dense
                    :show-size="1000"
                >
                    <template #selection="{index, text}">
                        <v-chip
                            label
                            small
                            close
                            @click:close="removeAttachment(index)"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                </v-file-input>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="actionLoading"
                    @click="saveProcessEntry()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'AddProcessEntryDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        processEntry: {
            type: Object,
            default: null
        },
        actionLoading: {
            type: Boolean
        },
        parentFolderId: {
            type: Number,
            default: null
        },
        parentFolderName: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            items: []

        }
    },
    validations() {
        return {
            processEntry: {
                name: {
                    required
                },
                description: {
                    required
                },
            }
        }
    },
    computed: {
        processSubjects() {
            return this.$store.state.wiki.wiki.processSubjects
        },
        processEntryNameErrors() {
            const errors = []

            if (!this.$v.processEntry.name.$dirty) return errors
            !this.$v.processEntry.name.required && errors.push('Tytuł jest wymagany.')

            return errors
        },
        processEntryDescriptionErrors() {
            const errors = []

            if (!this.$v.processEntry.description.$dirty) return errors
            !this.$v.processEntry.description.required && errors.push('Treść jest wymagana.')

            return errors
        },
        processEntryData() {
            let processEntryData = this.processEntry

            processEntryData.processSubjectId = this.parentFolderId
            
            return processEntryData
        }
    },
    methods: {
        saveProcessEntry() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.$emit('on-save', this.items)
                this.onClose()
            }
        },
        removeAttachment(item) {
            this.items.splice(this.items.indexOf(item), 1)
        },
        onClose() {
            setTimeout(() => {
                this.items = []
                this.$v.$reset()
            }, 500)
            this.$emit('on-close')
        },
    }
}
</script>
